import React, { Component } from "react"
import { Card, CardBody, CardTitle, Badge, Button, Container, Row, Col, Alert } from "reactstrap"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { connect } from "react-redux"
import "flatpickr/dist/themes/material_blue.css"
import logo from "../../assets/images/site-logo.png"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { withTranslation } from "react-i18next"
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import axios from "axios";
import { PublicHeader, PublicFooter, AgentCard, PinIcon } from "../../components/PublicLead";
import PhoneInputField from "components/Common/PhoneInput";
import {
  Label,
  Input,
  InputGroup,
  FormGroup,
  Nav,
  NavItem
} from "reactstrap";
class ProjectOpenHouseForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      projectData: '',
      formVisible: true,
      isLoading: true
    }
  }

  componentDidMount() {
    const { match: { params } } = this.props;
    this.setState({ isLoading: true });
    axios.get('https://rscoreapi.azurewebsites.net/api/ProjectExt/guid', {
      params: {
        projectid: params.openhouseid
      }
    })
      .then(res => {
        const projectData = res.data;
        this.setState({ projectData, isLoading: false });
      })

  }

  handleSubmit = (values, { setSubmitting }) => {
    const updateFeature = {
      projectCampaignId: values.projectCampaignId,
      agentId: values.agentId,
      campaignProjectId: values.campaignProjectId,
      campaignProjectGuid: values.campaignProjectGuid,
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      mobile: values.mobileNo,
      leadSourceId: values.leadSourceId,
      withAgent: values.withAgent,
      isActive: values.isActive
    };

    toast.loading("Please wait...");
    axios.post('https://rscoreapi.azurewebsites.net/api/ProjectCampaignLead', updateFeature, {
      headers: {
        'Content-Type': 'application/json',
        //'Authorization': str
      }
    })
      .then(response => {
        toast.dismiss();

        if (response.data.success) {
          toast.success("Saved");
          this.setState({
            formVisible: false,
            thankYouMessage: `We will contact you shortly to go over the next steps. If you have questions feel free to call at ${this.state.projectData?.agent?.firstName + " " + this.state.projectData?.agent?.lastName} or email at ${this.state.projectData?.agent?.primaryEmail}.`,
          });
        } else {
          response.data.validationErrors.forEach(error => {
            toast.error(error);
          });
        }
        // Handle success
      })
      .catch(error => {
        console.error(error);
        // Handle error
      });
  }
  formatPhoneNumber(phone) {
    if (!phone) return '';
    const cleaned = ('' + phone).replace(/\D/g, '');
    const lastTen = cleaned.slice(-10);
    const match = lastTen.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    return phone;
  }
  render() {
    const { projectData, formVisible, thankYouMessage, isLoading } = this.state;
    //console.log(projectData);
    return (
      <React.Fragment>
        {isLoading && isLoading ? (
          <div className="loading">Loading&#8230;</div>
        ) : null}
        <MetaTags>
          <title>{projectData?.projectName || 'Open House | Realty Space'}</title>
          {projectData?.projectLogoLink && (
            <link rel="icon" href={projectData.projectLogoLink} />
          )}
        </MetaTags>
        <ToastContainer autoClose={2000} />
        {this.state.projectData.isActive ? (
          <div className="rs-page rs-oh">
            <PublicHeader
              logoSrc={projectData?.agent?.logoFilePath || logo}
              projectLogo={projectData?.projectLogoLink}
            />
            <div className="rs-main">
              <div className="rs-col">
                <div className="rs-navy rs-curve">
                  {projectData?.projectLogoLink ? (
                    <img className="rs-project-logo" src={projectData.projectLogoLink} alt="" />
                  ) : (
                    <div className="rs-project-logo-box">Project logo</div>
                  )}
                  <div className="rs-kicker">Open house</div>
                  <h1>Welcome! Please sign in</h1>
                  <div className="rs-muted">{projectData?.projectName}</div>
                  {projectData?.projectSiteAddress?.fullAddress ? (
                    <a
                      className="rs-map-link"
                      href={`https://maps.google.com/?q=${encodeURIComponent(projectData.projectSiteAddress.fullAddress)}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <PinIcon />
                      <span>
                        {projectData.projectSiteAddress.fullAddress}{" "}
                        <span className="gold">Map</span>
                      </span>
                    </a>
                  ) : null}
                  <AgentCard
                    label="Your agent today"
                    firstName={projectData?.agent?.firstName}
                    lastName={projectData?.agent?.lastName}
                    phone={projectData?.agent?.agentContact?.cContact?.phone}
                    email={projectData?.agent?.primaryEmail}
                    showActions
                  />
                    </div>
              </div>
              <div className="rs-col">
                    {formVisible ? (
                      <Formik
                        enableReinitialize={true}
                        initialValues={{
                          projectCampaignId: 1100,
                          agentId: projectData.agentId,
                          campaignProjectId: projectData.id,
                          campaignProjectGuid: projectData.preConsProjectGuid,
                          firstName: (this.state && this.state.firstName) || "",
                          lastName: (this.state && this.state.lastName) || "",
                          email: (this.state && this.state.email) || "",
                          leadSourceId: 4,
                          mobileNo: (this.state && this.state.mobileNo) || "",
                          withAgent: '',
                          isActive: true
                        }}
                        validationSchema={Yup.object().shape({
                          firstName: Yup.string().required("This is Required"),
                          lastName: Yup.string().required("This is Required"),
                          email: Yup.string().required("This is Required"),
                          mobileNo: Yup.string()
                            .test("phone", "Enter a valid phone number", (value) => (value || "").replace(/\D/g, "").length >= 10)
                            .required("This is Required")
                        })}

                        onSubmit={this.handleSubmit}


                      >
                        {({ errors, touched, values, handleChange, setFieldValue }) => (
                          <Form className="rs-card-form">
                            <div>
                              <h2>Sign in for this open house</h2>
                              <p className="lead">So {projectData?.agent?.firstName} {projectData?.agent?.lastName} can follow up with details on this home. All fields are required.</p>
                            </div>
                            <div className="rs-grid-2">
                              <label className="rs-field">
                                First name *
                                <Field name="firstName" type="text" autoComplete="given-name" className={"rs-input" + (errors.firstName && touched.firstName ? " is-invalid" : "")} />
                                <ErrorMessage name="firstName" component="div" className="rs-error" />
                              </label>
                              <label className="rs-field">
                                Last name *
                                <Field name="lastName" type="text" autoComplete="family-name" className={"rs-input" + (errors.lastName && touched.lastName ? " is-invalid" : "")} />
                                <ErrorMessage name="lastName" component="div" className="rs-error" />
                                        </label>
                                      </div>
                            <div className="rs-grid-2">
                              <label className="rs-field">
                                Email *
                                <Field name="email" type="email" autoComplete="email" className={"rs-input" + (errors.email && touched.email ? " is-invalid" : "")} />
                                <ErrorMessage name="email" component="div" className="rs-error" />
                              </label>
                              <PhoneInputField
                                label="Phone"
                                name="mobileNo"
                                value={values.mobileNo || ""}
                                setFieldValue={setFieldValue}
                                error={errors.mobileNo}
                                touched={touched.mobileNo}
                                country="ca"
                                required
                              />
                            </div>
                            <fieldset className="rs-choices">
                              <legend>Are you currently working with an agent?</legend>
                              <div className="rs-choice-row">
                                <label className="rs-choice"><Field type="radio" name="withAgent" value="Yes" />Yes</label>
                                <label className="rs-choice"><Field type="radio" name="withAgent" value="No" />No</label>
                                      </div>
                            </fieldset>
                            <p className="rs-consent">By signing in, you agree that {projectData?.agent?.firstName} {projectData?.agent?.lastName} may contact you about this property and similar homes. You can unsubscribe at any time.</p>
                            <button type="submit" className="rs-submit">Sign in</button>
                          </Form>
                        )}
                      </Formik>
                    ) : (
                      <div className="rs-thanks">
                        <h2>Thank you</h2>
                       
                        <p>{thankYouMessage}</p>
                      </div>
                    )}
              </div>
            </div>
            <PublicFooter />
          </div>
        ) : (
          <div className="rs-page">
            <PublicHeader logoSrc={logo} />
            <div className="rs-empty"><h2>loading...</h2></div>
            <PublicFooter />
            </div>
        )}
      </React.Fragment>
    )
  }
}
ProjectOpenHouseForm.propTypes = {
  t: PropTypes.any,
  ongetProjectUUIDAction: PropTypes.func,
  match: PropTypes.object,
  addProjectOpenHouse: PropTypes.func,
  projectData: PropTypes.object,


}

const mapStateToProps = ({ Project }) => (
  {
    projectData: Project.projectData,
    loading: Project.loading

  })
const mapDispatchToProps = dispatch => ({
  ongetProjectUUIDAction: (id) => dispatch(getProjectUUIDAction(id)),
  addProjectOpenHouse: (data) => dispatch(addProjectOpenHouse(data)),


});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ProjectOpenHouseForm));


